import Button from '@/components/Button';
import ProductVariantChecklistComboBox from '@/components/ProductVariantChecklistComboBox';
import { ProductVariantSelectItem } from '@/components/ProductVariantSelectBox';

interface ProductListSkuAddFormProps {
  onSelect: (item?: ProductVariantSelectItem | null) => void;
  onDeselect?: (item: ProductVariantSelectItem) => void;
  stagedCount: number;
  excludedIds: (string | number)[];
  productListId?: string;
  onAdd: () => Promise<void> | void;
  submitting?: boolean;
}

const ProductListSkuAddForm = ({
  onSelect,
  onDeselect,
  stagedCount,
  excludedIds,
  productListId,
  onAdd,
  submitting = false,
}: ProductListSkuAddFormProps) => (
  <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-end">
    <div className="w-full sm:max-w-md">
      <ProductVariantChecklistComboBox
        onSelect={onSelect}
        onDeselect={onDeselect}
        selectedIds={excludedIds}
        productListId={productListId}
        disabled={submitting}
      />
    </div>

    <div className="flex items-center gap-3">
      <Button
        onClick={() => void onAdd()}
        loading={submitting}
        disabled={stagedCount === 0}
        variant="primary"
      >
        Add selected SKUs
      </Button>
      {stagedCount > 0 && (
        <span className="text-sm text-gray-600">
          {stagedCount} {stagedCount === 1 ? 'SKU' : 'SKUs'} selected
        </span>
      )}
    </div>
  </div>
);

export default ProductListSkuAddForm;
